var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.00016H2.33333M2.33333 4.00016H13M2.33333 4.00016L2.33333 13.3335C2.33333 13.6871 2.47381 14.0263 2.72386 14.2763C2.97391 14.5264 3.31304 14.6668 3.66667 14.6668H10.3333C10.687 14.6668 11.0261 14.5264 11.2761 14.2763C11.5262 14.0263 11.6667 13.6871 11.6667 13.3335V4.00016M4.33333 4.00016V2.66683C4.33333 2.31321 4.47381 1.97407 4.72386 1.72402C4.97391 1.47397 5.31304 1.3335 5.66667 1.3335H8.33333C8.68696 1.3335 9.02609 1.47397 9.27614 1.72402C9.52619 1.97407 9.66667 2.31321 9.66667 2.66683V4.00016M5.66667 7.3335V11.3335M8.33333 7.3335V11.3335",
    stroke: "#2F2F2F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bfa34bba78a967e391b5bd4b4274c123.svg";
export { ForwardRef as ReactComponent };